import { platDocument } from './env';

export function createCookiesMap(str) {
  const jar = {};
  const cookies = str ? str.split(/;\s?/) : [];
  cookies.forEach((parts) => {
    const cookie = parts.split(/=/);
    jar[cookie[0]] = cookie[1];
  });
  // console.log('cookiesMap', jar);
  return jar;
}

const _private = {};
_private.param = {};

/**
 * 设置cookie
 * @param {string} name 名称
 * @param {string|number} [value] 值
 * @param {object} param 属性
 * @param {string} [param.domain] 域名
 * @param {string} [param.path] 路径
 * @param {number|Date} [param.expires] 有效时间
 * @param {boolean} [param.secure] 是否HTTPS
 * @return {boolean} 是否设置成功
 * @example qv.cookie.set('qv_cookieName','Hello world！',{domain:'vip.qq.com',path:'/',expires:24*60*60,secure:true});
 */
export const setCookie = function (name, value, param) {
  if (name === '') {
    return false;
  }
  param = { ..._private.param, ...param };
  if (typeof (value) === 'undefined' || value == null) {
    value = '';
  }
  if (typeof (param.expires) === 'number') {
    const { expires } = param;
    param.expires = new Date();
    param.expires.setTime(param.expires.getTime() + (expires * 1000));
  }
  platDocument.cookie = [
    encodeURIComponent(name), '=', encodeURIComponent(value),
    param.domain ? `; domain=${param.domain}` : '',
    param.path ? `; path=${param.path}` : '',
    param.expires ? `; expires=${param.expires.toUTCString()}` : '',
    param.secure ? '; secure' : '',
  ].join('');
  return true;
};

/**
 * 获取cookie
 * @param {string} name 名称
 * @return {?string} 值
 * @example qv.cookie.get('qv_cookieName');
 */
export const getCookie = function (name) {
  if (platDocument.cookie && platDocument.cookie !== '') {
    const cookieArr = platDocument.cookie.split('; ');
    name = encodeURIComponent(name);
    for (let i = 0, cl = cookieArr.length, tmpArr; i < cl; i++) {
      tmpArr = cookieArr[i].split('=');
      if (name === tmpArr[0]) {
        let result = '';
        try {
          result = decodeURIComponent(tmpArr[1] || '');
        } catch (e) {
          result = tmpArr[1] || '';
        }

        return result;
      }
    }
  }
  return null;
};

/**
 * 清除cookie
 * @param {string} name 名称
 * @param {object} param 属性
 * @param {string} [param.domain] 域名
 * @param {string} [param.path] 路径
 * @param {number|Date} [param.expires] 有效时间
 * @param {boolean} [param.secure] 是否HTTPS
 * @return {boolean} 是否清除成功
 * @example qv.cookie.clear('qv_cookieName');
 */
export const clearCookie = function (name, param) {
  return setCookie(name, null, { expires: -1, ...param });
};

export default {
  set: setCookie,
  get: getCookie,
  clear: clearCookie,
};
